module.exports = __webpack_public_path__ + "static/media/im.71db2a49.webp";